import React, { useState } from "react";
import "./Services.css";
import Navbars from "../components/Navbar/Navbars";
import Footer from "../components/Footer/Footer";
import ServicesNav from "../pages/Services/ServicesNav"; // Adjust import path if necessary
import crop2 from "../assets/crop2.jpg";
import shoe2 from "../assets/shoe2.jpg";
import ani2 from "../assets/ani2.jpg";
import water1 from "../assets/water1.jpg";
import wood1 from "../assets/wood1.jpg";
import clothe1 from "../assets/clothe1.jpg";
import Bread from "../assets/Bread.jpg";
// Each service component’s content (details and image)
const serviceDetails = {
  crop: {
    title: "Crop Production",
    description: `It is our strong belief that crop production can provide millions of jobs for Southern Nigerian
    youths. In the Southern Nigeria, we have thousands of hectares of lands that have fallowed for
    many decades yet unused. In Southern Nigeria, we have seventeen states. All these states
    (except Lagos state) have massive farmlands that people do not utilize because most people
    either consider agriculture as what poor people do or do not have the resources to engage in
    mechanized agriculture. It is for this reason that hunger has become the order of the day in the
    country yet Nigeria as a country boasts of having massive farmlands and overwhelming young
    population capable of putting these lands into judicious uses. It is for this reason that Geega
    Resources is going to be engaging the youths into what it terms Production, Processing and
    Marketing (PPM) of various agricultural products to tackle the food insecurity bedeviling
    Nigeria.
    It is on the above reasons that Geega Resources is going to engage the Southern Nigerian
    youths in massive agricultural activities including but not limited to the production of rice, yam,
    cassava, maize, beans, vegetables, fruits, palm trees, bananas, plantains etc. It is our belief
    that these will help to make foods abundant for Nigerians.`,
    image: crop2,
  },
  animal: {
    title: "Animal and Fish Farming",
    description: `We strongly believe that youths can be engaged to mass produce meat for the country. To this
    effect, Geega resources is going to be engaging the youths in Southern Nigeria in meat
    production through poultry, fishery, piggery etc.`,
    image: ani2,
  },
  clothes: {
    title: "Clothe Production",
    description: `Geega Resources is going to be engaging a segment of the youths in clothe productions. This,
    the organization will do by importing industrial sewing machines and all the necessary
    materials into Nigeria and using it to engage the youths to massively produce clothes
    particularly the ready-to-wears. These shall be made accessible and affordable to the poor
    masses.`,
    image: clothe1,
  },
  shoe: {
    title: "Shoe Production",
    description: `Geega Resources is going to be importing the relevant machinery and materials used in shoe
    production and use them to engage youths in the Southern Nigeria in shoe production,
    packaging and marketing at highly subsidized prices for the poor masses in Nigeria.`,
    image: shoe2,
  },
  furniture: {
    title: "Furniture Production",
    description: `Geega Resources is going to be importing chainsaw and other equipment, and materials used
    in wooden furniture production such as domestic and office tables and chairs, beds and other
    stuffs that can be produced with woods. A segment of the youths in Southern Nigeria is going
    to be engaged in these activities and the furniture produced are going to be sold at a highly
    subsidized prices to Nigerians.`,
    image: wood1,
  },
  baking: {
    title: "Baking Bread Products",
    description: `To further tackle the problem of food insecurity in Nigeria, Geega Resources is going to be
    importing various machinery and equipment used in baking of bread and similar products such
    as doughnuts, eggrolls, cakes Etc. A segment of the youths is going to be trained to undertake
    these activities, the baked products are going to be sold at highly subsidized prices.`,
    image: Bread,
  },
  water: {
    title: "Table Water Production",
    description: `A segment of the youths is going to be trained and engaged in sachet water and table water
    production. This is to ensure that there is sufficiency of supply of water across the regions. The
    cost of these products is currently exorbitant and therefore highly unaffordable for the common
    Nigerians. Nigeria is a very sunny country and therefore people need to be highly hydrated in
    other to function properly in the society. To this effect, Geega Resources is going to be
    importing the necessary machinery and equipment used in sachet water and table water
    production into Southern Nigeria and engage the youths to mass produce these products and
    sell them at highly subsidized rate to Nigerians.`,
    image: water1,
  },
};

const Services = () => {
  const [selectedService, setSelectedService] = useState("crop");

  const handleServiceClick = (serviceKey) => {
    setSelectedService(selectedService === serviceKey ? null : serviceKey); // Toggle the service
  };

  return (
    <div className="services-page">
      <Navbars />
      <ServicesNav
        onServiceClick={handleServiceClick}
        selectedService={selectedService}
      />
      <div className="service-content">
        {selectedService && (
          <div className="service-details">
            <h2>{serviceDetails[selectedService].title}</h2>
            <p>{serviceDetails[selectedService].description}</p>
            <img
              src={serviceDetails[selectedService].image}
              alt={serviceDetails[selectedService].title}
              className="show-image"
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Services;
